import { observer } from 'mobx-react';
import * as React from 'react';
import Main from '../../BrowserSupport/Main';
import NotificationSource from '../../NotificationSource';
import Notifications from '../../Notifications';
import ReportsStore from '../../ReportsStore';
import ReportsReactions from '../../ReportsStore/ReportsReaction';
import I18nTitle from '../../Title/I18nTitle';
import { T } from '../../Translations';
import ClickableTooltip from '../ClickableTooltip';
import TooltipIcon from '../Cutesies/TooltipIcon';
import MainNav from '../Platform/MainNav';
import ReportsState from './ReportsState';

interface Props {}

@observer
class Reports extends React.Component<Props, {}> {
  private reportsStore: ReportsStore = new ReportsStore();

  constructor(props: Props) {
    super(props);
    this.reportsStore.loading();
  }

  render() {
    return (
      <>
        <I18nTitle title="Your Reports" />
        <div className="min-h-screen">
          <MainNav />
          <Notifications />
          <div className="bg-white border-b-1 pb-4 border-b-gray-200">
            <div className="max-w-clientPortalMaxWidth mx-auto w-full overflow-x-hidden">
              <div className="flex flex-col justify-between md:flex-row lg:px-12 px-2.5">
                <div>
                  <div>
                    <div className="flex items-center">
                      <h2 className="text-2xl font-semibold text-gray-900 items-center">
                        <T kind="Reports" />
                      </h2>
                      <ClickableTooltip tooltipId={'reports'} tooltipIcon={<TooltipIcon />}>
                        {
                          <T
                            kind={'Discover critical insights, analyze...'}
                            link={(content) => (
                              <a
                                href="https://execonline.atlassian.net/l/cp/pJp12UKU"
                                rel="nofollow noopener noreferrer"
                                target="_blank"
                                className="text-teal-400 underline"
                              >
                                {content}
                              </a>
                            )}
                          />
                        }
                      </ClickableTooltip>
                    </div>
                  </div>
                  <div className="pt-5 pb-2">
                    <T kind="View and download data insights ..." />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="max-w-clientPortalMaxWidth mx-auto">
            <Main id="main" className="min-h-[calc(100vh-150px)]">
              <NotificationSource store={this.reportsStore} />
              <ReportsState store={this.reportsStore} />
              <ReportsReactions store={this.reportsStore} fireImmediately={true} />
            </Main>
          </div>
        </div>
      </>
    );
  }
}

export default Reports;
